"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Mail, MessageCircle, Linkedin, Twitter, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
function IrisMark({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </svg>;
}
const tickerText = "HOTELREVBABA  ·  REVENUE MANAGEMENT";
const services = [{
  label: "Hotel Revenue Management Consulting",
  to: "/HotelRevenueManagementConsultingPage"
}, {
  label: "Dynamic Pricing & Forecasting",
  to: "/DynamicPricingForecastingServicesPage"
}, {
  label: "Channel Manager Setup",
  to: "/ChannelManagerSetupDistributionStrategyPage"
}, {
  label: "Rate Parity & Leakage Control",
  to: "/RateParityLeakageControlPage"
}, {
  label: "Hotel Website SEO",
  to: "/HotelWebsiteSEOBookingEngineOptimizationPage"
}, {
  label: "Revenue Intelligence Framework",
  to: "/RevenueIntelligenceFrameworkOurMethodologyPage"
}, {
  label: "Tool Expertise & Tech Stack",
  to: "/ToolExpertiseTechnologyStackPage"
}];
const resources = [{
  label: "FAQ & Glossary",
  to: "/ResourcesPage"
}, {
  label: "Google Hotel Ads",
  to: "/HotelAdsPaidMediaServicesPage"
}, {
  label: "Meta Advertising",
  to: "/HotelAdsPaidMediaServicesPage"
}, {
  label: "TripAdvisor Marketing",
  to: "/OTARevenueManagementListingsPage"
}, {
  label: "Revenue Blog",
  to: "/BlogPage"
}, {
  label: "Commercial Insights",
  to: "/BlogPage"
}, {
  label: "About Agency",
  to: "/AboutPage"
}, {
  label: "Contact/Support",
  to: "/ContactPage"
}];
const quickLinks = [{
  label: "Free Audit",
  to: "/FreeAudit"
}, {
  label: "Services",
  to: "/HotelRevenueManagementConsultingPage"
}, {
  label: "Contact",
  to: "/Contact"
}, {
  label: "Pricing",
  to: "/Pricing"
}, {
  label: "Portfolio",
  to: "/Portfolio"
}];
export default function FooterInformation() {
  return <section data-section-id="1798" id="footer-information" className="bg-[#0B4D9C] text-white py-16 relative overflow-hidden font-sans">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center">
        <span className="w-2 h-2 bg-secondary -ml-1" />
        <span className="flex-1 h-px bg-secondary/30" />
        <span className="w-2 h-2 bg-secondary -mr-1" />
      </div>

      {}
      <div className="relative overflow-hidden border-b border-white/10 group">
        <div className="flex whitespace-nowrap py-5 group-hover:[animation-play-state:paused]" style={{
        animation: "footer-ticker 40s linear infinite"
      }}>
          {[0, 1, 2, 3].map(rep => <div key={rep} data-index={rep} className="flex items-center font-mono text-xs tracking-[0.18em] uppercase text-white/60 shrink-0">
              {tickerText.split("·").map((chunk, i) => <span key={i} data-index={i} className="flex items-center">
                  <span className="px-4">{chunk.trim()}</span>
                  <IrisMark className="w-3 h-3 text-secondary shrink-0" />
                </span>)}
            </div>)}
        </div>
        <style>{`
          @keyframes footer-ticker {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-12">
        {}
        <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50 mb-12">
          § 09 — HOTELREVBABA · REVENUE ARCHITECTS
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-3">
              <Link to="/" aria-label="HotelRevBaBa - Home" className="flex items-center gap-3">
                <WvcLogo className="h-7 w-auto" />
              </Link>
              <IrisMark className="w-6 h-6 text-secondary" />
            </div>

            <div className="flex flex-col gap-5">
              <p className="font-sans text-lg leading-relaxed text-white/90">
                Maximizing hotel revenue through data-driven OTA strategies.
              </p>
              
              <Link to="#">
                <Button variant="secondary" className="w-full sm:w-auto rounded-lg font-bold">
                  Get Your Free Revenue Audit
                </Button>
              </Link>

              <div className="flex items-center gap-3">
                <span className="w-10 h-px bg-secondary" />
                <span className="w-1 h-1 bg-secondary rounded-lg" />
              </div>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-white/60 leading-relaxed">
                Global Consulting
                <br />
                Available for Partnerships
              </p>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-white/60">
                sunil.singh@hotelrevbaba.com
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Services
            </div>
            <nav>
              <ul className="flex flex-col gap-3">
                {services.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="text-white/80 hover:text-white font-sans text-sm tracking-wide relative inline-block group transition-colors">
                      <span className="relative">
                        {item.label}
                        <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                      bottom: "-4px"
                    }} />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Resources
            </div>
            <nav>
              <ul className="flex flex-col gap-3">
                {resources.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="text-white/80 hover:text-white font-sans text-sm tracking-wide relative inline-block group transition-colors">
                      <span className="relative">
                        {item.label}
                        <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                      bottom: "-4px"
                    }} />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Quick Links
            </div>
            <nav>
              <ul className="flex flex-col gap-3">
                {quickLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="text-white/80 hover:text-white font-sans text-sm tracking-wide relative inline-block group transition-colors">
                      <span className="relative">
                        {item.label}
                        <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                      bottom: "-4px"
                    }} />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Contact
            </div>
            <ul className="flex flex-col gap-4">
              <li data-index={0}>
                <Link to="#revenue_journey_form_contact" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <SafeHydrate><Calendar className="w-4 h-4 stroke-[1.5]" /></SafeHydrate>
                  <span className="relative">
                    Schedule Consultation
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="https://wa.me/917972195929" newTab aria-label="Chat on WhatsApp for Free Revenue Audit" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <MessageCircle className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    WhatsApp
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
              <li data-index={2}>
                <Link to="mailto:sunil.singh@hotelrevbaba.com" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <Mail className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    Email Us
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
              <li data-index={3}>
                <Link to="https://www.linkedin.com/company/hotel-revbaba" newTab aria-label="Follow HotelRevBaBa on LinkedIn" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <Linkedin className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    LinkedIn
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
              <li data-index={4}>
                <Link to="https://twitter.com" newTab aria-label="Follow HotelRevBaBa on Twitter" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <Twitter className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    Twitter
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 flex items-center">
          <span className="w-2 h-2 bg-secondary rounded-lg" />
          <span className="flex-1 h-px bg-secondary/30" />
          <span className="w-2 h-2 bg-secondary rounded-lg" />
        </div>

        {}
        <div className="flex justify-center my-12">
          <IrisMark className="w-12 h-12 md:w-14 md:h-14 text-secondary" />
        </div>

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/40">
            © 2026 HOTELREVBABA · REVENUE MANAGEMENT
          </p>
          <ul className="flex items-center gap-6 md:gap-8">
            {[{
            label: "Terms",
            to: "#"
          }, {
            label: "Privacy",
            to: "#"
          }, {
            label: "Legal",
            to: "#"
          }].map((item, i) => <li key={item.label} data-index={i}>
                <Link to={item.to} className="text-white/40 font-mono text-[0.6875rem] tracking-[0.18em] uppercase hover:text-secondary transition-colors duration-300">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      {}
      <div>
        <Link to="https://wa.me/917972195929?text=Hi%20Sunil,%20I%27d%20like%20a%20free%20revenue%20audit" newTab aria-label="Chat on WhatsApp for Free Revenue Audit">
          <Button className="fixed bottom-4 right-4 z-50 h-14 rounded-lg bg-[#25D366] hover:bg-[#25D366]/90 text-white shadow-lg px-6 flex items-center justify-center font-bold">
            <span>Start Your Free Audit on WhatsApp</span>
          </Button>
        </Link>
      </div>
    </section>;
}